<template>
  <div>
    <div class="grid-container" >
      <div class="block1 " v-show="isSingle == false">
        <search-control-block :all_disabled="b1_disabled" block_id="1" @change="onChange" :field_names="field_names"  
            style="padding:0px 0px;marging:0px 0px 0px 0px;" ></search-control-block>
      </div>
      <div class="" v-show="isSingle == true" style="width:320px;">
        <search-control-block :all_disabled="b1_disabled" block_id="1" @change="onChange" :field_names="field_names"  
            style="padding:0px 0px;marging:0px 0px 0px 0px;" ></search-control-block>
      </div>
      <div class="block_btn "  v-show="isSingle == false">
        <button 
          style="width: 100px;float: left;margin-left: 35px;" 
          class="btn btn-primary esma_btn_form btn-xs" @click="clearBarcode">検索クリア</button>
      </div>

    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import { bus } from '@/libs/bus'
import Vue from 'vue';

import debug from 'debug';
var debug_search_control = debug('esma:page_common');
import {filed_types} from "@/rules/fields";
import searchControlBlock from "@/components/search_control_block";
import { bus } from '@/libs/bus'

export default {
  components: {
    "search-control-block": searchControlBlock
  },
  data() {
    return {
      bock_info:{1:false,2:false,3:false,j1:"AND",j2:"AND",b2_disabled:false,b3_disabled:false},
      b1_disabled:false,
      j1_disabled:true,
      b2_disabled:true,
      j2_disabled:true,
      b3_disabled:true,
      j1_enabled_between:false, // search_with_between step3
      j2_enabled_between:false
    };
  },

  computed: {
    j1EnabledBetween:{
      get(){
        return this.j1_enabled_between;
      },
      set(v){
        this.j1_enabled_between = v;
      }
    },
    j2EnabledBetween:{
      get(){
        return this.j2_enabled_between;
      },
      set(v){
        this.j2_enabled_between = v;
      }
    },
    filedList(){
      return this.field_names.map(o=>{
        return {id:o.id,label:o.label,type:o.type}
      })
    },
    dateFilterOptions: {
      get() {
        return [];
      },
      set(v) {
      }
    },
    isSingle(){
      return this.single == true;
    }
  },
    methods: {
    clearBarcode(ev){
      ev.preventDefault();
      bus.$emit("onSearchClear","");
    },
    andOr(v,id)
    {
      this.bock_info[id] = v;
      this.processAndEmit();
    },
    onChange(d){
      this.bock_info[d.block] = d
      this.processAndEmit();
    },
    processAndEmit(){
       this.b2_disabled = false;
      this.b3_disabled = false;
      this.j1_disabled = false;
      this.j2_disabled = false;
      this.j1EnabledBetween = false; // search_with_between step4
      this.j2EnabledBetween = false;
      if(this.bock_info["1"] == false || this.bock_info["1"].value==""){
        this.b2_disabled = true;
        this.b3_disabled = true;
        this.j1_disabled = true;
        this.j2_disabled = true;
      }
      if(this.bock_info["2"] == false || this.bock_info["2"].value==""){
        this.b3_disabled = true;
        this.j2_disabled = true;
      }
      // search_with_between step5
      if(this.bock_info["1"] != false && this.bock_info["2"] != false && this.bock_info["1"].field == this.bock_info["2"].field && ( this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0) ){
        this.j1EnabledBetween = true; 
      }else if(this.bock_info.j1 == "BETWEEN"){
        this.bock_info.j1 = "AND";
      }
      if(this.bock_info["2"] != false && this.bock_info["3"] != false && this.bock_info["2"].field == this.bock_info["3"].field  && ( this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0) ){
        this.j2EnabledBetween = true;
      }else if(this.bock_info.j2 == "BETWEEN"){
        this.bock_info.j2 = "AND";
      }
      this.bock_info["b2_disabled"] = this.b2_disabled ;
      this.bock_info["b3_disabled"] = this.b3_disabled ;
      console.log("Data changed",JSON.stringify(this.bock_info,null,4))
      this.$emit("change",this.bock_info);
    },
    onFilterTypeSelected(val, id){
      console.log({val,id})
    },
    onDateFilterSelected() {
    }
  },
  beforeMount() {},
  mounted() {
    // May use it to recreate the list of allowed items to search. 
    // After this, it is necessary to visit each page.
    // var arr =  JSON.parse(Vue.localStorage.get('temp_search_fields') || "[]");
    // this.field_names.map((o)=>{return o.id}).forEach(f=>{
    //   if(arr.indexOf(f) < 0){
    //     arr.push(f)
    //   }
    // })
    // Vue.localStorage.set('temp_search_fields', JSON.stringify(arr)) 
    // console.log("field_names",arr)
  },
  afterMount() {},
  beforeDestroy() {},
  props: ['field_names','single']
};
</script>

<style scoped>
.grid-container {
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 40fr 10fr 40fr 10fr 40fr 15fr;
  grid-template-columns: 40fr 10fr 40fr 10fr 40fr 15fr;
  -ms-grid-rows: 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "block1  join1  block2  join2  block3 block_btn";
}

.block1  { -ms-grid-row: 1; -ms-grid-column: 1; grid-area: block1 ; }

.join1  { -ms-grid-row: 1; -ms-grid-column: 2; grid-area: join1 ; }

.block2  { -ms-grid-row: 1; -ms-grid-column: 3; grid-area: block2 ; }

.join2  { -ms-grid-row: 1; -ms-grid-column: 4; grid-area: join2 ; }

.block3  { -ms-grid-row: 1; -ms-grid-column: 5; grid-area: block3 ; }

.block_btn  { -ms-grid-row: 1; -ms-grid-column: 6; grid-area: block_btn ; }
</style>



// WEBPACK FOOTER //
// search_control_maker.vue?2b494948